import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SimpleVideoplayerComponent } from './simple-videoplayer.component';
import { VgCoreModule } from '../_modules/player/core';
import { VgControlsModule } from '../_modules/player/controls';
import { VgOverlayPlayModule } from '../_modules/player/overlay-play';
import { VgBufferingModule } from '../_modules/player/buffering';
import { VgOverlayDanmuModule } from '../_modules/player/overlay-danmu';
import { VgStreamingModule } from '../_modules/player/streaming';
import { VgPauseAdsModule } from '../_modules/player/puase-ads/pause-ads';
import { VgMediaTitleModule } from '../_modules/player/media-title/media-title';

@NgModule({
    declarations: [
        SimpleVideoplayerComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        VgOverlayDanmuModule,
        VgStreamingModule,
        VgPauseAdsModule,
        VgMediaTitleModule,
    ],
    exports: [
        SimpleVideoplayerComponent,
    ]
})
export class SimpleVideoplayerModule { }